import { Chip } from '@heroui/react';
import type { ParkingSpotStatus } from '../../../api/condominiums';
import { getParkingSpotStatusLabel } from '../../admin/utils/parking-spot-status';

const STATUS_COLOR: Record<
  ParkingSpotStatus,
  'default' | 'accent' | 'success' | 'warning' | 'danger'
> = {
  OCCUPIED: 'danger',
  AVAILABLE: 'success',
  BORROWED: 'success',
  RENTED: 'accent',
};

export function SpotStatusChip({ status }: { status: ParkingSpotStatus }) {
  return (
    <Chip size="sm" variant="soft" color={STATUS_COLOR[status] ?? 'default'}>
      {getParkingSpotStatusLabel(status)}
    </Chip>
  );
}
